import React, { FC } from 'react';
import { Stack } from '@mui/material';
import { FilterChipsProps } from './types';
import { StyledTag } from '../StyledTag';

const FilterChips: FC<FilterChipsProps> = ({ filterKey, values, onRemove }) => {
  const renderChips = () => {
    switch (filterKey) {
      case 'years_of_experience': {
        if (!values) return null;
        const range = values as { min?: number | null; max?: number | null };
        const hasMin = range.min !== undefined && range.min !== null;
        const hasMax = range.max !== undefined && range.max !== null;
        if (!hasMin && !hasMax) return null;
        const label = hasMin && hasMax
          ? `${range.min} to ${range.max} years`
          : hasMin
            ? `${range.min}+ years`
            : `Up to ${range.max} years`;
        return <StyledTag label={label} onDelete={() => onRemove(filterKey)} />;
      }

      case 'job_titles':
      case 'industries':
      case 'locations': {
        if (!Array.isArray(values)) return null;
        return (values as string[]).map((value: string, index: number) => (
          <StyledTag
            key={`${filterKey}-${value}-${index}`}
            label={value}
            onDelete={() => onRemove(filterKey, index)}
          />
        ));
      }

      case 'skills': {
        if (!Array.isArray(values)) return null;
        return (values as string[][]).map((skillGroup, groupIndex) =>
          skillGroup.map((skill, skillIndex) => (
            <StyledTag
              key={`skills-${skill}-${groupIndex}-${skillIndex}`}
              label={skill}
              onDelete={() => onRemove(filterKey, groupIndex, skillIndex)}
            />
          ))
        );
      }

      default:
        return null;
    }
  };

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {renderChips()}
    </Stack>
  );
};

export default FilterChips;
